// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/css/components/skill.less
// module id = 116
// module chunks = 0